import { lazyLoad } from 'utils/loadable';

export const EntityBalanceReportPage = lazyLoad(
  () => import('./index'),
  module => module.EntityBalanceReportPage
);
